module.exports = __webpack_public_path__ + "static/media/copacetic-business-solution-ltd.d8d6f7fd.jpg";